import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    inputField: {
        '& .MuiInputBase-root': {
            color: '#5A5A5A',
            backgroundColor: '#fff',
            borderRadius: '8px',
        },
        '& .MuiOutlinedInput-multiline':{
            padding: '1.5px 2px 2px 15px',
        },
        '& .MuiOutlinedInput-root': {
            '& fieldset': {
                borderColor: '#FFAB46',
                borderWidth:'2px',
            },
            '&:hover fieldset': {
                borderColor: '#FFAB46',
            },
            '&.Mui-focused fieldset': {
                borderColor: '#FFAB46',
            },
        },
    },
    iconButton: {
        color: 'white',
        backgroundColor: '#EE6628',
        '&:hover': {
            backgroundColor: '#EE6628',
        },
        padding: '10px',
        borderRadius: '0%',
    },
    container: {
        width: '100%',           // Ensures it fills the parent width
        maxWidth: 'inherit',      // Inherits any maxWidth from the parent
        display: 'flex',          // Aligns child elements responsively
        flexDirection: 'column',  // Column layout for chat and input
        height: '100%',
        margin: '0 auto',
        borderRadius:'7px',
        padding: '0px',
    },
    inputWrapper: {
        position: 'relative',
        display: 'flex',
        width: '100%',
        alignItems: 'center',
    },
    loaderContainer: {
        display: 'inline-block',
        padding: '10px',
        borderRadius: '8px',
        backgroundColor: '#e0e0e0',
    },

    loader: {
        border: '6px solid #f3f3f3', // Light grey
        borderTop: '6px solid #555', // Darker grey
        borderRadius: '50%',
        width: '24px',
        height: '24px',
        animation: '$spin 1s linear infinite',
    },

    '@keyframes spin': {
        '0%': { transform: 'rotate(0deg)' },
        '100%': { transform: 'rotate(360deg)' },
    },
}));
export default useStyles;